import MonthGrid from './MonthGrid';
import useInfiniteCalendar from './useInfiniteCalendar';

/**
 * Calendar (mobile) - vertically scrolling list of months with stable infinite scroll.
 *
 * The month range, initial scroll-to-today positioning, and edge loading are all handled
 * by useInfiniteCalendar. This component is the bounded scroll container itself, so it must
 * not be wrapped in another overflow-y-auto element.
 */
function Calendar({ calendarData, startMonth, endMonth, onStartMonthChange, onEndMonthChange, userId = null, calendarId = null }) {
  const { scrollRef, months, handleScroll } = useInfiniteCalendar({
    onStartMonthChange,
    onEndMonthChange,
  });

  return (
    <div
      ref={scrollRef}
      onScroll={handleScroll}
      className="h-full overflow-y-auto scrollbar-hide"
      style={{ overflowAnchor: 'none' }}
    >
      {months.map((ms) => (
        <div id={`month-${ms}-${userId}`} key={ms}>
          <MonthGrid monthString={ms} calendarData={calendarData} userId={userId} calendarId={calendarId} />
        </div>
      ))}
    </div>
  );
}

export default Calendar;